import React from 'react';
import { Box } from '@mui/material';

const Paragraph = ({ children }) => {
    if (typeof children === 'string') {
        return <Box sx={{ color: '#555555'}} dangerouslySetInnerHTML={{ __html: children }} />;
    }
    return <Box sx={{ color: '#555555' }}>{children}</Box>;
};

export default Paragraph;